import { createAsyncThunk } from '@reduxjs/toolkit';
import { getKeys } from '@/libs/helpers/utils';
import { InsurerField, PassengerField } from './interface';
import { FORMS_STATE_NAMESPACE, formsActions } from './index';
const passengerFields = getKeys(PassengerField);
export const validateForms = createAsyncThunk('', async (_, thunkApi) => {
    const { [FORMS_STATE_NAMESPACE]: { passengers, insurer, emails, hasAgreePersonalData, }, } = thunkApi.getState();
    const checkArePassengersValid = () => passengers.every((passenger) => passengerFields.every((field) => !passenger.fieldsErrors[field]));
    const insurerFields = [
        InsurerField.birthday,
        InsurerField.phoneBody,
        InsurerField.firstName,
        InsurerField.lastName,
    ];
    const checkIsInsurerValid = () => insurerFields.every((field) => !insurer.fieldsErrors[field]);
    const checkIsEmailsValid = () => emails.every((email) => !email.errorMessage);
    const checkIsHasAgreeValid = () => hasAgreePersonalData.value;
    const isFormValidated = checkArePassengersValid() &&
        checkIsInsurerValid() &&
        checkIsEmailsValid() &&
        checkIsHasAgreeValid();
    thunkApi.dispatch(formsActions._setFormValidated(isFormValidated));
});
